import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useFetchPeOrderDetailQuery } from 'rtkQuery/sharespro/queries/peService';

import PeCompanyDataView from 'presentation/components/modules/pe/shared/detail/PeCompanyDataView';

const PeSelfOrderDetailPage: FC = () => {
  const { id } = useParams();
  const orderId = +(id as string);
  const { isFetching, data, refetch, error } = useFetchPeOrderDetailQuery({
    id: orderId,
  });

  return (
    <PeCompanyDataView
    assetId={+(id as string)}
      isFetching={isFetching}
      data={data?.company}
      refetch={() => {
        refetch();
      }}
      error={error}
    />
  );
};

export default PeSelfOrderDetailPage;
